import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { DictionaryEntry } from '../../types';

export default function Dictionary() {
  const [entries, setEntries] = useState<DictionaryEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [language, setLanguage] = useState<string>('all');

  useEffect(() => {
    const fetchEntries = async () => {
      setLoading(true);
      let query = supabase
        .from('dictionary_entries')
        .select('*')
        .order('word');

      if (language !== 'all') {
        query = query.eq('language', language);
      }

      if (search) {
        query = query.ilike('word', `%${search}%`);
      }

      const { data } = await query.limit(50);
      setEntries(data || []);
      setLoading(false);
    };
    fetchEntries();
  }, [search, language]);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Diccionario Bíblico</h1>
      
      <input
        type="text"
        placeholder="Buscar palabra..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="input"
      />

      <div className="flex gap-2">
        <button
          onClick={() => setLanguage('all')}
          className={`px-3 py-1 rounded-lg text-sm ${language === 'all' ? 'bg-primary text-white' : 'bg-[#3A3A3C]'}`}
        >
          Todos
        </button>
        <button
          onClick={() => setLanguage('greek')}
          className={`px-3 py-1 rounded-lg text-sm ${language === 'greek' ? 'bg-primary text-white' : 'bg-[#3A3A3C]'}`}
        >
          Griego
        </button>
        <button
          onClick={() => setLanguage('hebrew')}
          className={`px-3 py-1 rounded-lg text-sm ${language === 'hebrew' ? 'bg-primary text-white' : 'bg-[#3A3A3C]'}`}
        >
          Hebreo
        </button>
        <button
          onClick={() => setLanguage('aramaic')}
          className={`px-3 py-1 rounded-lg text-sm ${language === 'aramaic' ? 'bg-primary text-white' : 'bg-[#3A3A3C]'}`}
        >
          Arameo
        </button>
      </div>

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
        </div>
      ) : entries.length === 0 ? (
        <div className="card text-center py-8">
          <p className="text-[#8E8E93]">No hay entradas</p>
        </div>
      ) : (
        <div className="space-y-2">
          {entries.map((entry) => (
            <Link
              key={entry.id}
              to={`/dictionary/${entry.id}`}
              className="card block "
            >
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-white">{entry.word}</h3>
                    <span className="text-xs bg-[#3A3A3C] px-2 py-0.5 rounded">{entry.strong_number}</span>
                  </div>
                  {entry.transliteration && (
                    <p className="text-sm text-[#8E8E93] italic">{entry.transliteration}</p>
                  )}
                  <p className="text-sm text-[#B3B3B3] mt-1 line-clamp-2">{entry.definition}</p>
                </div>
                <span className={`text-xs px-2 py-1 rounded ${
                  entry.language === 'greek' ? 'bg-blue-100 text-blue-700' :
                  entry.language === 'hebrew' ? 'bg-purple-100 text-purple-700' :
                  'bg-orange-100 text-orange-700'
                }`}>
                  {entry.language === 'greek' ? 'Griego' : entry.language === 'hebrew' ? 'Hebreo' : 'Arameo'}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
